import React, { useEffect, useState } from "react";
import classes from "./MobileApp.module.css";
import { ReactComponent as FirstTruck } from "../../assets/firstTruckSvg.svg";
import { ReactComponent as SecondTruck } from "../../assets/secondTruckSvg.svg";
import { ReactComponent as AppleIcon } from "../../assets/appleIcon.svg";
import { ReactComponent as AndroidIcon } from "../../assets/AndroidIcon.svg";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MobileAppImage from "../../assets/mockup.png";
import { Image } from "antd";
import useLang from "../../hooks/useLang";

const MobileApp = () => {
	const { strings } = useLang("mobileApp");
	const [value, setValue] = useState(0);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 994);

	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 994);
		};

		window.addEventListener("resize", handleResize);

		handleResize();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className={classes.bossContainer}>
			<div className={classes.mainContainer}>
				<div className={classes.textContainer}>
					<h1 className={classes.h1Text}>Aplikacioni Mobil</h1>
					<p className={classes.pText}>
						Aplikacioni ynë mobil është një mjet i avancuar dhe i
						lehtë për të përdorur, i cili ofron një përvojë të
						përshtatshme dhe të lehtë për klientët tanë në
						menaxhimin e dërgesave të tyre.
					</p>
				</div>
			</div>
			<div className={classes.secondContainer}>
				<div className={classes.textContainer}>
					<div className={classes.thirdTextContainer}>
						<p className={classes.thirdTitle}>
							Aplikacioni mobil për klient
						</p>
						<p>
							Tani ju mund ta shkarkoni dhe ta përdorni
							aplikacionin mobil, i cili është zhvilluar
							specifikisht për të ju mbajtur të informuar në çdo
							kohë rreth llogarisë tuaj Postman si dhe për të ju
							lehtësuar regjistrimin dhe menagjimin e porosive
							përmes telefonit tuaj mobil.
						</p>
					</div>
				</div>
			</div>
			<div className={classes.tabsContainer}>
				{isMobile ? (
					<>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="basic tabs example"
								variant="scrollable"
							>
								{strings?.tabs.map(
									(tab: any, index: number) => (
										<Tab
											key={index}
											label={
												<div className="text-start">
													<p
														className={
															classes.tabTitle
														}
													>
														{tab.title}
													</p>
													<p
														className={
															classes.tabContent
														}
													>
														{tab.content}
														{(tab.title ===
															"Download Our Mobile App:" ||
															tab.title ===
																"Shkarkoni aplikacionin tonë mobil:") && (
															<div
																className={
																	classes.iconContainer
																}
															>
																<AndroidIcon />
																<AppleIcon />
															</div>
														)}
													</p>
												</div>
											}
										/>
									)
								)}
							</Tabs>
						</Box>
						<Box>
							{value === 0 && (
								<Box>
									<Image
										src={MobileAppImage}
										preview={false}
									/>
								</Box>
							)}
							{value === 1 && (
								<Box>
									<Image
										src={MobileAppImage}
										preview={false}
									/>
								</Box>
							)}
							{value === 2 && (
								<Box>
									<Image
										src={MobileAppImage}
										preview={false}
									/>
								</Box>
							)}
							{value === 3 && (
								<Box>
									<Image
										src={MobileAppImage}
										preview={false}
									/>
								</Box>
							)}
						</Box>
					</>
				) : (
					<>
						<FirstTruck className={classes.firstTruck} />
						<div className={classes.tabContainer}>
							<Box>
								<Tabs
									orientation="vertical"
									variant="scrollable"
									aria-label="Vertical tabs example"
									sx={{
										borderRight: 1,
										borderColor: "divider",
									}}
									className={classes.tabs}
									value={value}
									onChange={handleChange}
								>
									{strings?.tabs.map(
										(tab: any, index: number) => (
											<Tab
												key={index}
												label={
													<div className="text-start">
														<p
															className={
																classes.tabTitle
															}
														>
															{tab.title}
														</p>
														<p
															className={
																classes.tabContent
															}
														>
															{tab.content}
															{tab.title ===
																"Download Our Mobile App:" ||
															tab.title ===
																"Shkarkoni aplikacionin tonë mobil:" ? (
																<div
																	className={
																		classes.iconContainer
																	}
																>
																	<AndroidIcon />
																	<AppleIcon />
																</div>
															) : null}
														</p>
													</div>
												}
											/>
										)
									)}
								</Tabs>
								<Box className=" flex items-center">
									{value === 0 && (
										<Box>
											<Image
												src={MobileAppImage}
												preview={false}
											/>
										</Box>
									)}
									{value === 1 && (
										<Box>
											<Image
												src={MobileAppImage}
												preview={false}
											/>
										</Box>
									)}
									{value === 2 && (
										<Box>
											<Image
												src={MobileAppImage}
												preview={false}
											/>
										</Box>
									)}
									{value === 3 && (
										<Box>
											<Image
												src={MobileAppImage}
												preview={false}
											/>
										</Box>
									)}
								</Box>
							</Box>
						</div>
						<SecondTruck className={classes.secondTruck} />
					</>
				)}
			</div>
			{/* <NewsDiv /> */}
		</div>
	);
};

export default MobileApp;
